import jwtDecode from 'jwt-decode';
import { jwtConfig } from '../settings';
import SuperFetch from './superFetch';

class AuthHelper {
  login = async userInfo => {
    if (!userInfo.username || !userInfo.password) {
      return { error: 'Username and password required' };
    }
    const info = { userid: userInfo.username, password: userInfo.password };
    console.log('POST user/login:');
    const result = await SuperFetch.post('user/login', info, false);
    console.log(result);
    if (result.Status === 'error') return { error: result.Message };
    if (result.error) return { error: 'Server error. Please try again.' };
    if (result.token) {
      result.profile = jwtDecode(result.token);
    }
    return result;
  };

  forgotPassword = async userInfo => {
    if (!userInfo.username || !userInfo.email) {
      return { result: 'Username and email address required' };
    }
    const queryLogin = `?userid=${encodeURIComponent(
      userInfo.username
    )}&emailaddress=${encodeURIComponent(userInfo.email)}`;
    console.log('GET user/forgotpassword queryString:');
    console.log(JSON.stringify(queryLogin));
    const result = await SuperFetch.get('user/forgotpassword' + queryLogin);
    return result;
  };

  signup = async userInfo => {
    if (!userInfo.username || !userInfo.password) {
      return { error: 'Username and password required' };
    }

    // build the header
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userInfo),
    };
    return await fetch(`${jwtConfig.fetchUrl}user/register`, requestOptions)
      .then(response => response.json())
      .then(res => {
        return res;
      })
      .catch(error => ({ error }));
  };

  async checkAuthPage(token) {
    if (this.checkExpirity(token).error) {
      return { error: 'Token expired' };
    }
    return await SuperFetch.post('user/test', { token })
      .then(response => ({
        status: '200',
        message: 'Success',
      }))
      .catch(error => ({ error: JSON.stringify(error) }));
  }

  checkExpirity = token => {
    if (!token) {
      return {
        error: 'not matched',
      };
    }
    try {
      const profile = jwtDecode(token);

      const expiredAt = profile.expiredAt || profile.exp * 1000;

      if (expiredAt > new Date().getTime()) {
        return {
          ...profile,
          token,
          expiredAt: new Date(expiredAt),
        };
      } else {
        return { error: 'Token expired' };
      }
    } catch (e) {
      return { error: 'Server Error' };
    }
  };
}
export default new AuthHelper();
